import * as THREE from "three";
import { Vector3 } from "three";

class Helix extends THREE.Curve {
  radius;
  length;
  windings_per_unit;

  constructor(radius, length, windings_per_unit) {
    super();
    this.radius = radius;
    this.length = length;
    this.windings_per_unit = windings_per_unit;
  }
  getPoint(t, optionalTarget) {
    const point = optionalTarget || new Vector3();

    const alpha = 2 * Math.PI * t * this.windings_per_unit * this.length;
    point.set(
      this.radius * Math.cos(alpha),
      this.length * t,
      this.radius * Math.sin(alpha)
    );
    return point;
  }
}

export default class CoilBufferGeometry extends THREE.ExtrudeBufferGeometry {
  constructor(radius, length, windings_per_unit, small_radius) {
    const shape = new THREE.Shape();
    shape.absarc(0, 0, small_radius, 0, 2 * Math.PI, false);

    super(shape, {
      extrudePath: new Helix(radius, length, windings_per_unit),
      steps: windings_per_unit * length * 30,
      depth: 1
    });
  }
}
